import { render, staticRenderFns } from "./NewPaymentProvision.vue?vue&type=template&id=8adf2144&"
import script from "./NewPaymentProvision.vue?vue&type=script&lang=js&"
export * from "./NewPaymentProvision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports